var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"168fa5566efabde8b36944548cf1bf424a862ef2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["home-waste-web@clearabee"]={id:"168fa5566efabde8b36944548cf1bf424a862ef2"};
      